import React, { useContext, useEffect, useRef, useState } from "react";
import { classNames } from "primereact/utils";
import { useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { RTLContext } from "./App";
import { UserSessionUtils } from "./app_utils/utils/UserSessionUtils";
import { BaseApiServiceImpl } from "./app_utils/api/BaseApiServiceImpl";

const AppTopbar = (props: any) => {
  const isRTL = useContext(RTLContext);
  const history = useHistory();
  const isAdmin = UserSessionUtils.isSuperAdmin();
  const [alertCount, setAlertCount] = useState(0);

  // Fixed for 6.1.0
  // eslint-disable-next-line
  const searchPanel = useRef(null);

  useEffect(() => {
    // Fixed for 6.1.0
    /*if (props.searchActive) {
            searchPanel.current.element.focus();
        }*/
  }, [props.searchActive]);

  useEffect(() => {
    if (!isAdmin) return;
    const fetchAlertCount = () => {
      new BaseApiServiceImpl("/api/v1/gateway-health/alerts/count")
        .getRequestWithJsonResponse({})
        .then((response) => {
          setAlertCount(response?.data?.count || 0);
        })
        .catch(() => {});
    };
    fetchAlertCount();
  }, [isAdmin]);

  const onInputKeydown = (event: any) => {
    const key = event.which;

    //escape, tab and enter
    if (key === 27 || key === 9 || key === 13) {
      props.onSearch(false);
    }
  };

  const model = [
    {
      label: "UI KIT",
      items: [
        [
          {
            label: "UI KIT 1",
            items: [
              {
                label: "Form Layout",
                icon: "pi pi-fw pi-id-card",
                command: () => {
                  history.push("/uikit/formlayout");
                },
              },
              {
                label: "Input",
                icon: "pi pi-fw pi-check-square",
                command: () => {
                  history.push("/uikit/input");
                },
              },
              {
                label: "Float Label",
                icon: "pi pi-fw pi-bookmark",
                command: () => {
                  history.push("/uikit/floatlabel");
                },
              },
              {
                label: "Button",
                icon: "pi pi-fw pi-mobile",
                command: () => {
                  history.push("/uikit/button");
                },
              },
              {
                label: "File",
                icon: "pi pi-fw pi-file",
                command: () => {
                  history.push("/uikit/file");
                },
              },
            ],
          },
        ],
        [
          {
            label: "UI KIT 2",
            items: [
              {
                label: "Table",
                icon: "pi pi-fw pi-table",
                command: () => {
                  history.push("/uikit/table");
                },
              },
              {
                label: "List",
                icon: "pi pi-fw pi-list",
                command: () => {
                  history.push("/uikit/list");
                },
              },
              {
                label: "Tree",
                icon: "pi pi-fw pi-share-alt",
                command: () => {
                  history.push("/uikit/tree");
                },
              },
              {
                label: "Panel",
                icon: "pi pi-fw pi-tablet",
                command: () => {
                  history.push("/uikit/panel");
                },
              },
              {
                label: "Chart",
                icon: "pi pi-fw pi-chart-bar",
                command: () => {
                  history.push("/uikit/chart");
                },
              },
            ],
          },
        ],
        [
          {
            label: "UI KIT 3",
            items: [
              {
                label: "Overlay",
                icon: "pi pi-fw pi-clone",
                command: () => {
                  history.push("/uikit/overlay");
                },
              },
              {
                label: "Menu",
                icon: "pi pi-fw pi-bars",
                command: () => {
                  history.push("/uikit/menu");
                },
              },
              {
                label: "Message",
                icon: "pi pi-fw pi-comment",
                command: () => {
                  history.push("/uikit/message");
                },
              },
              {
                label: "Misc",
                icon: "pi pi-fw pi-circle",
                command: () => {
                  history.push("/uikit/misc");
                },
              },
            ],
          },
        ],
      ],
    },

    {
      label: "PAGES",
      items: [
        [
          {
            label: "PAGES 1",
            items: [
              {
                label: "Access",
                icon: "pi pi-fw pi-lock",
                command: () => {
                  history.push("/access");
                },
              },
              {
                label: "Calendar",
                icon: "pi pi-fw pi-calendar-plus",
                command: () => {
                  history.push("/pages/calendar");
                },
              },
            ],
          },
          {
            label: "PAGES 2",
            items: [
              {
                label: "Crud",
                icon: "pi pi-fw pi-pencil",
                command: () => {
                  history.push("/pages/crud");
                },
              },
              {
                label: "Empty Page",
                icon: "pi pi-fw pi-circle",
                command: () => {
                  history.push("/pages/empty");
                },
              },
            ],
          },
        ],
        [
          {
            label: "PAGES 3",
            items: [
              {
                label: "Timeline",
                icon: "pi pi-fw pi-calendar",
                command: () => {
                  history.push("/pages/timeline");
                },
              },
              {
                label: "Help",
                icon: "pi pi-fw pi-question-circle",
                command: () => {
                  history.push("/pages/help");
                },
              },
            ],
          },
          {
            label: "PAGES 4",
            items: [
              {
                label: "Invoice",
                icon: "pi pi-fw pi-dollar",
                command: () => {
                  history.push("/pages/invoice");
                },
              },
              {
                label: "Landing",
                icon: "pi pi-fw pi-globe",
                command: () => {
                  history.push("/landing");
                },
              },
            ],
          },
        ],
        [
          {
            label: "PAGES 5",
            items: [
              {
                label: "Login",
                icon: "pi pi-fw pi-sign-in",
                command: () => {
                  history.push("/login");
                },
              },
              {
                label: "Not Found",
                icon: "pi pi-fw pi-exclamation-circle",
                command: () => {
                  history.push("/notfound");
                },
              },
              {
                label: "Error",
                icon: "pi pi-fw pi-times-circle",
                command: () => {
                  history.push("/error");
                },
              },
            ],
          },
        ],
      ],
    },
  ];

  return (
    <div className="layout-topbar shadow-4">
      <div className="layout-topbar-left">
        <button
          type="button"
          style={{ cursor: "pointer" }}
          className="layout-topbar-logo p-link"
          onClick={() => history.push("/")}
        >
          <img
            id="app-logo"
            src="assets/layout/images/logo-white.png"
            alt="ultima-layout"
            style={{ height: "2.9rem" }}
          />
        </button>
        <button
          type="button"
          className="layout-menu-button shadow-6 p-link"
          onClick={props.onMenuButtonClick}
        >
          <i className="pi pi-chevron-right"></i>
        </button>
        <button type="button" className="layout-topbar-mobile-button p-link">
          <i className="pi pi-ellipsis-v fs-large" onClick={props.onMobileTopbarButtonClick}></i>
        </button>
      </div>

      <div
        className={classNames("layout-topbar-right", {
          "layout-topbar-mobile-active": props.mobileTopbarActive,
        })}
      >
        <div className="layout-topbar-actions-left">
          {/* <MegaMenu model={model} className="layout-megamenu" /> */}
        </div>
        <div className="layout-topbar-actions-right">
          <ul className="layout-topbar-items">
            {isAdmin && alertCount > 0 && (
              <li className="layout-topbar-item">
                <button
                  className="layout-topbar-action rounded-circle p-link"
                  onClick={() => history.push("/home")}
                  title={`${alertCount} gateway alert${alertCount !== 1 ? "s" : ""}`}
                  style={{ position: "relative" }}
                >
                  <i className="pi pi-bell" style={{ fontSize: "1.2rem" }} />
                  <span
                    style={{
                      position: "absolute",
                      top: "-2px",
                      right: "-2px",
                      background: "#dc2626",
                      color: "white",
                      borderRadius: "9999px",
                      minWidth: "18px",
                      height: "18px",
                      fontSize: "0.7rem",
                      fontWeight: 700,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0 4px",
                    }}
                  >
                    {alertCount > 99 ? "99+" : alertCount}
                  </span>
                </button>
              </li>
            )}
            <li className="layout-topbar-item">
              <button
                className="layout-topbar-action rounded-circle p-link"
                onClick={(event) =>
                  props.onTopbarItemClick({
                    originalEvent: event,
                    item: "profile",
                  })
                }
              >
                <img
                  src="assets/layout/images/profile-image.png"
                  alt="avatar"
                  style={{ width: "32px", height: "32px" }}
                />
              </button>

              <CSSTransition
                classNames="p-toggleable"
                timeout={{ enter: 1000, exit: 450 }}
                in={props.activeTopbarItem === "profile"}
                unmountOnExit
              >
                <ul className="layout-topbar-action-panel shadow-6">
                  <li className="layout-topbar-action-item">
                    <button
                      onClick={() => {
                        history.push("/profile");
                      }}
                      className="flex flex-row align-items-center p-link"
                    >
                      <i
                        className={classNames("pi pi-user", {
                          "mr-2": !isRTL,
                          "ml-2": isRTL,
                        })}
                      ></i>
                      <span>My Profile</span>
                    </button>
                  </li>
                  <li className="layout-topbar-action-item">
                    <button
                      onClick={() => {
                        history.push("/wallet");
                      }}
                      className="flex flex-row align-items-center p-link"
                    >
                      <i
                        className={classNames("pi pi-wallet", {
                          "mr-2": !isRTL,
                          "ml-2": isRTL,
                        })}
                      ></i>
                      <span>Top Up Wallet</span>
                    </button>
                  </li>
                  <li className="layout-topbar-action-item">
                    <button
                      onClick={() => {
                        history.push("/api-keys");
                      }}
                      className="flex flex-row align-items-center p-link"
                    >
                      <i
                        className={classNames("pi pi-key", {
                          "mr-2": !isRTL,
                          "ml-2": isRTL,
                        })}
                      ></i>
                      <span>API Keys</span>
                    </button>
                  </li>
                  <li className="layout-topbar-action-item">
                    <button
                      onClick={() => {
                        UserSessionUtils.logout(history);
                      }}
                      className="flex flex-row align-items-center p-link"
                    >
                      <i
                        className={classNames("pi pi-power-off", {
                          "mr-2": !isRTL,
                          "ml-2": isRTL,
                        })}
                      ></i>
                      <span>Logout</span>
                    </button>
                  </li>
                </ul>
              </CSSTransition>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AppTopbar;
